import React, { FC, useMemo } from 'react';
import PaymentMode, { calculateTotal } from './PaymentMode';
import _ from 'lodash';
import moment from 'moment';

const FixedDatesMode: FC<any> = ({ mode, total, selected }: any) => {
  const installments = useMemo<any[]>(() => {
    const calculatedTotal = calculateTotal(total, mode.discount);
    let installments: any[] = [];

    const todayInstallment = { date: 'today', percent: 0 };

    for (const installment of mode.installments) {
      if (new Date(installment.date) < new Date()) {
        todayInstallment.percent += parseInt(installment.percent);
      } else {
        installments.push(installment);
      }
    }

    if (todayInstallment.percent > 0) {
      installments = [todayInstallment, ...installments];
    }

    for (const installment of installments) {
      installment.amount = Math.round(calculatedTotal * (installment.percent / 100));
    }

    const adjustment = calculatedTotal - _.sumBy(installments, 'amount');
    const adjustedInstallment = adjustment > 0 ? _.first(installments) : _.last(installments);
    adjustedInstallment.amount = adjustedInstallment.amount + adjustment;

    return installments;
  }, [total]);

  return (
    <PaymentMode mode={mode} selected={selected}>
      <div className="title">{`${installments.length} Payment Plan`}</div>
      <div className="installments">
        {installments.map((installment, index) => (
          <div key={index}>
            <span className="price">{`${(installment.amount / 100).toFixed(2)}$ `}</span>
            <span>
              {installment.date == 'today' ? 'Due Today' : `on ${moment(installment.date).format('YYYY-MM-DD')}`}
            </span>
          </div>
        ))}
      </div>
    </PaymentMode>
  );
};

export default FixedDatesMode;
